<template>
  <span id="start">
    <v-container fluid>
      <template v-for="(post, index) in media">
        <v-card :key="index" elevation="0" max-width="100%" color="white" hover>
          <v-card-title v-if="post.url" class="title">
            <a class="title_link" v-bind:href="post.url" :target="'_blank'">{{post.title}}</a>
          </v-card-title>
          <v-card-title v-else class="title">{{post.title}}</v-card-title>
          <v-card-subtitle class="subtitle">{{post.subtitle}}</v-card-subtitle>
          <template v-if="post.html">
            <v-row class="nomargin">
              <template v-if="post.image">
                <v-col v-if="post.html_text.split('<br><br>').length<=4" cols="12" md="8">
                  <p class="text" v-html="post.html_text"></p>
                </v-col>
                <v-col v-else cols="12" md="8">
                  <p
                    class="text"
                    v-html="post.html_text.split('<br><br>').slice(0,4).join('<br><br>')"
                  ></p>
                </v-col>
              </template>
              <v-col v-else cols="12">
                <p class="text" v-html="post.html_text"></p>
              </v-col>
              <v-col v-if="post.image" cols="12" md="4">
                <v-img class="imagenes" contain :src="post.mediaUrl" />
              </v-col>
              <v-col v-if="post.html_text.split('<br><br>').length>4 && post.image" cols="12">
                <p class="text" v-html="post.html_text.split('<br><br>').slice(4).join('<br><br>')"></p>
              </v-col>
              <v-col v-if="post.video" cols="12">
                <video-player
                  v-if="!post.youtube"
                  class="vjs-custom-skin"
                  ref="videoPlayer"
                  :options="getOptions(post.mediaUrl)"
                  :playsinline="true"
                />
                <youtube v-else :video-id="getIdFromUrl(post.mediaUrl)"></youtube>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row class="nomargin">
              <v-col v-if="post.image" cols="12">
                <v-img class="imagenes" contain :src="post.mediaUrl" />
              </v-col>

              <v-col v-if="post.video && (post.mediaUrl || post.youtube)" cols="12">
                <video-player
                  v-if="!post.youtube"
                  class="vjs-custom-skin"
                  ref="videoPlayer"
                  :options="getOptions(post.mediaUrl)"
                  :playsinline="true"
                />
                <youtube v-else :video-id="getIdFromUrl(post.mediaUrl)"></youtube>
              </v-col>
            </v-row>
          </template>
          <template v-if="post.paper_html">
            <v-row class="nomargin">
              <v-col cols="12">
                <p class="paper-link" v-html="post.paper_html_text"></p>
              </v-col>
            </v-row>
          </template>
          <v-divider class="divider" />
        </v-card>
      </template>
    </v-container>
  </span>
</template>

<script>
import { mapState } from "vuex";
import { getIdFromURL } from "vue-youtube-embed";

export default {
  name: "MediaContent",
  methods: {
    getIdFromUrl(url) {
      return getIdFromURL(url);
    },
    getOptions(url) {
      return {
        height: "360",
        autoplay: false,
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: url.includes("selectscience")
              ? "https://www.selectscience.net/videos/SSci_CON20_SLAS_Jan20_116_Dr_Shrike_Zhang_V2.mp4"
              : url
          }
        ]
      };
    }
  },
  computed: mapState(["loadingMedia", "media"]),
  mounted() {
    if (!this.media.length) this.$store.dispatch("cargarMedia");
    //console.log(this.media)
  }
};
</script>

<style scoped>
.nomargin {
  margin: 0;
}

/deep/.urll {
  text-decoration-line: none;
  color: #b80b0b !important;
  font-style: italic;
}

/deep/a {
  text-decoration-line: none;
  color: #b80b0b !important;
  font-style: italic;
}

/deep/.video-js {
  margin: auto;
  max-width: 100%;
}

.title {
  text-align: justify;
  font-size: 3.2vmin !important;
  word-break: break-word;
  margin-bottom: 0.7rem;
}

.subtitle {
  text-align: start;
  word-break: break-word;
  font-size: 2.2vmin !important;
}

.text {
  text-align: justify;
  word-break: break-word;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  font-size: 2.4vmin !important;
}

.divider {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}

.paper-link {
  text-align: end;
  font-size: 2vmin !important;
  font-style: italic;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  margin: 0;
}

.imagenes {
  max-height: 600px;
  max-width: 100%;
}

.title_link {
  text-decoration-line: none;
  color: #b80b0b;
}

.videocontainer {
  max-height: 100%;
}

.video {
  margin: auto;
  width: 75%;
}

@media only screen and (max-width: 960px) {
  .imagenes {
    max-height: 300px;
    max-width: 100%;
  }
  .video {
    width: 100%;
  }
}

@media only screen and (max-width: 700px) {
  .imagenes {
    max-height: 300px;
    max-width: 350px;
    align-self: center;
    margin: auto;
  }
  .video {
    width: 100%;
  }
}
</style>